/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { Input, Modal, RadioGroup, Tooltip } from '../../../../UiKit';
import styled from 'styled-components';
import { EmptyState } from '../../../commons';
import { defaultIssueImg, InvalidSearchImg } from '../../../../images/images';
import { GroupedReasons } from '../../ReportIssue/Issues/GroupedReasons/GroupedReasons';
import ReportIssue from '../../ReportIssue/ReportIssue';
import { ClockPlus } from 'lucide-react';
import { Check, ChevronRight, Copy, Cross, Plus, Remove } from 'sushiweb/Icons';
import { grey, green, red } from 'sushiweb/tokens/color';
import {
  ACTION_TYPES,
  dropdownInputCSS,
  getTagStyles,
  SERIALIZE_INPUT_TYPE,
  TAB_INDEXES,
  TASK_STATUSES,
  TaskSourceLabels,
} from '../constants';
import toast from 'react-hot-toast';
import { MultiMedia } from '../../../../UiKit/multimedia/multimedia';
import ZImage from 'sushiweb/ZImage';
import Multiselect from 'multiselect-react-dropdown';
import MultiSelectViewV2 from '../../ReportIssue/Issues/common/MultiSelectView/MultiSelectV2';
import { PanelRightClose } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { closeActionView } from '../../../../store/basicOrder/actions';
import { IS_SIDEBAR_CLOSE } from '../../../../store/basicOrder/reducers';
import { DSR_COMMENT } from '../../ReportIssue/Issues/OrderSpilled/constants';

const dashboardMode = window.dashboard.mode;

const IssueTitle = ({ isPendingIssueList, item }) => {
  if (!item) return null;
  return (
    <div
      className={`tw-flex tw-justify-between tw-w-full tw-px-8 ${
        isPendingIssueList ? 'tw-text-red-600' : ''
      } `}
    >
      {isPendingIssueList ? (
        <div className='tw-flex tw-items-center tw-justify-center'>
          <span className='tw-text-white tw-bg-red-600 tw-rounded-full tw-w-7 tw-h-7 tw-flex tw-justify-center tw-items-center tw-mr-4 tw-text-200 tw-font-bold'>
            {item?.issues?.length}
          </span>
          <span
            className={
              'pending_issue_title tw-font-medium tw-text-[1.4rem] tw-text-zinc-600'
            }
          >
            {item.title}
          </span>
        </div>
      ) : (
        <span
          className={`tw-font-medium tw-text-[1.4rem] ${
            item.disabled ? 'tw-text-zinc-400' : 'tw-text-zinc-600'
          }`}
        >
          {item.title}
        </span>
      )}

      {item?.issues?.length > 0 || item.expandable_issue ? (
        item.is_collapsed ? (
          <Plus
            size={20}
            color={`${isPendingIssueList ? red.z700 : green.z700}`}
          />
        ) : (
          <Remove
            size={20}
            color={`${isPendingIssueList ? red.z700 : green.z700}`}
          />
        )
      ) : (
        <ChevronRight size={20} color={item.disabled ? grey.z400 : grey.z700} />
      )}
    </div>
  );
};

const ExpandableIssueChildComp = ({
  item,
  orderLevelPayload,
  handleOrderLevelPayload,
  handleExpandableIssueSubmit,
}) => {
  return (
    <div
      className={
        'tw-flex-col tw-gap-4 tw-px-8 tw-py-6 tw-leading-none tw-font-regular tw-text-200 tw-rounded-lg tw-w-full tw-justify-between'
      }
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div className='tw-font-medium tw-text-zinc-800'>Refund Amount</div>
      <div className='tw-flex tw-gap-2 tw-items-center'>
        <input
          type='number'
          placeholder='Enter Refund Amount (₹)'
          className='tw-w-full tw-p-4 tw-rounded-lg tw-shadow-none tw-border tw-border-solid tw-border-grey-200'
          value={orderLevelPayload?.[item?.expandable_issue?.key_for_evaluate]}
          onChange={(e) => {
            handleOrderLevelPayload(
              e,
              item?.expandable_issue?.key_for_evaluate,
              item?.expandable_issue?.max_refund_amount,
            );
          }}
        />
        <span
          className={` ${
            orderLevelPayload?.[item.expandable_issue.key_for_evaluate]
              ? 'tw-cursor-pointer tw-border-green-700'
              : 'tw-cursor-not-allowed tw-border-grey-200'
          } tw-border-solid tw-border-1 tw-rounded-lg tw-h-full tw-aspect-square tw-flex tw-items-center tw-justify-center`}
          onClick={(e) => {
            if (!orderLevelPayload?.[item.expandable_issue.key_for_evaluate]) {
              return;
            }
            handleExpandableIssueSubmit(e, item);
          }}
        >
          <ChevronRight
            size={23}
            color={
              orderLevelPayload?.[item.expandable_issue.key_for_evaluate]
                ? green.z700
                : grey.z400
            }
          />
        </span>
      </div>
    </div>
  );
};

const ExpandableCommentIssueChild = ({ item, handleExpandableIssueSubmit }) => {
  const [comment, setComment] = useState('');

  const handleChevronClick = (e) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(DSR_COMMENT, comment);
    }
    handleExpandableIssueSubmit(e, item);
  };

  return (
    <div
      className={
        'tw-flex-col tw-gap-4 tw-px-8 tw-py-6 tw-leading-none tw-font-regular tw-text-200 tw-rounded-lg tw-w-full tw-justify-between'
      }
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div className='tw-font-medium tw-text-zinc-800'>Comment</div>
      <div className='tw-flex tw-gap-2 tw-items-center'>
        <input
          type='text'
          placeholder={item.expandable_issue.placeholder}
          className='tw-w-full tw-p-4 tw-rounded-lg tw-shadow-none tw-border tw-border-solid tw-border-grey-200'
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <span
          className={
            'tw-cursor-pointer tw-border-green-700 tw-border-solid tw-border-1 tw-rounded-lg tw-h-full tw-aspect-square tw-flex tw-items-center tw-justify-center'
          }
          onClick={handleChevronClick}
        >
          <ChevronRight size={23} color={green.z700} />
        </span>
      </div>
    </div>
  );
};

const IssuesListV2 = ({
  items = [],
  isPendingIssueList = false,
  handleActionClick = () => {},
  setcomplaintType,
}) => {
  const [issueReasons, setIssueReasons] = useState(items);
  const [orderLevelPayload, setOrderLevelPayload] = useState({});

  useEffect(() => {
    setIssueReasons(items);
  }, [items]);

  const handleClickIssue = (index, e) => {
    e.stopPropagation();
    const updatedApplicableReasons = issueReasons.map((item, ind) => {
      let updatedItem = {};
      if (ind === index) {
        updatedItem = {
          ...item,
          is_collapsed: item.is_collapsed ? false : true,
        };
      } else {
        updatedItem = {
          ...item,
          is_collapsed: true,
        };
      }
      return updatedItem;
    });
    setIssueReasons(updatedApplicableReasons);
  };

  const handleOrderLevelPayload = (e, key, max_val = 0) => {
    let val = Math.min(e.target.value, max_val);
    setOrderLevelPayload((prevState) => ({ ...prevState, [key]: Number(val) }));
  };

  const handleExpandableIssueSubmit = (e, item) => {
    e.stopPropagation();
    setcomplaintType(item.slug);
    handleActionClick(item, isPendingIssueList, orderLevelPayload);
  };

  return (
    <div className='tw-flex tw-flex-col tw-mx-5 tw-scroll-pb-96'>
      {issueReasons?.map((item, index) => {
        return (
          <div
            className={`tw-w-full tw-flex tw-flex-col tw-my-2 tw-mx-0  tw-bg-grey-100 tw-font-medium tw-text-200 tw-rounded-lg ${
              item.disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'
            } ${
              item?.is_collapsed === undefined
                ? 'tw-py-5'
                : item.is_collapsed === true
                ? 'hover:tw-bg-grey-200 tw-py-5'
                : 'tw-pt-5'
            }`}
            key={index}
            disabled={item.disabled}
            onClick={(e) => {
              if (item?.issues?.length > 0 || item?.expandable_issue) {
                handleClickIssue(index, e);
              } else {
                e.stopPropagation();
                setcomplaintType(item.slug);
                handleActionClick(item, isPendingIssueList);
              }
            }}
          >
            <IssueTitle isPendingIssueList={isPendingIssueList} item={item} />

            {(item?.issues?.length > 0 ||
              item.expandable_issue?.enabled ||
              item.expandable_issue?.is_comment_required) &&
            !item.is_collapsed ? (
              <div className={`tw-flex tw-flex-col`}>
                <hr
                  color='#CFCFCF'
                  className='tw-border-[0.5px] tw-my-3 tw-mb-0'
                />

                {item?.issues?.map((issue, index) => {
                  return (
                    <div
                      className={`tw-flex tw-flex-col tw-py-4 tw-px-8 tw-bg-grey-100 tw-font-regular tw-text-200 tw-rounded-lg ${
                        isPendingIssueList ? '' : 'hover:tw-text-green-700'
                      } hover:tw-bg-grey-200`}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleActionClick(issue, isPendingIssueList);
                        setcomplaintType(issue.slug);
                      }}
                      key={index}
                    >
                      <div className='tw-flex tw-justify-between tw-w-full'>
                        {isPendingIssueList ? (
                          <div className='tw-w-full tw-flex tw-flex-col'>
                            <span className='tw-font-medium'>
                              {issue.title}
                            </span>
                            <span className='tw-text-300 tw-text-blue-700 tw-font-medium '>
                              {issue.approved_items}
                            </span>
                          </div>
                        ) : (
                          <span>{issue.title}</span>
                        )}

                        <ChevronRight size={20} color={grey.z700} />
                      </div>
                    </div>
                  );
                })}

                {/* Expandable issues (delight resolution, "other" c-type in dsr flow) */}
                {item.expandable_issue?.enabled ? (
                  <ExpandableIssueChildComp
                    item={item}
                    orderLevelPayload={orderLevelPayload}
                    handleOrderLevelPayload={handleOrderLevelPayload}
                    handleExpandableIssueSubmit={handleExpandableIssueSubmit}
                  />
                ) : null}

                {/* Comment box */}
                {item.expandable_issue?.is_comment_required ? (
                  <ExpandableCommentIssueChild
                    item={item}
                    handleExpandableIssueSubmit={handleExpandableIssueSubmit}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export const ActiveAction = ({
  pageIndex = 0,
  activeActionIndex = TAB_INDEXES.REPORT_ISSUE,
  list = null,
  orderId = null,
  cartId = null,
  userId = null,
  resetSmartplugState = false,
  searchedError = false,
  handleCardLink = () => {},
  handleActionClick = () => {},
  onSearchAction = () => {},
  isResolutionService = false,
  complaintType,
  setcomplaintType = () => {},
  goBack = () => {},
  currentAction = null,
  liveOrderConfigData,
  newTasksCount = 0,
}) => {
  const dispatch = useDispatch();
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI); // Ensure correct state mapping
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState(null);
  const [selectedProductCodes, setSelectedProductCodes] = useState([]);
  const [isMarkAsCompleteDisabled, setIsMarkAsCompleteDisabled] =
    useState(false);

  let errorText = searchedError
    ? 'No data available for this search'
    : 'Everything looks fine';
  let errorSubtext = searchedError
    ? ''
    : 'If something goes wrong, use this panel for all the help needed';

  // Check if Mark as Complete button should be disabled
  const checkMarkAsCompleteDisabled = () => {
    if (!selectedOption?.slug) return true;

    // No reasons selected for approve/reject
    if (
      (selectedOption?.slug === ACTION_TYPES.Approve ||
        selectedOption?.slug === ACTION_TYPES.Reject) &&
      selectedOption?.final_reasons?.mandate_check &&
      !selectedOption?.finalSelectedReason
    )
      return true;

    // No quantity selected for stepper
    if (
      selectedOption?.slug === ACTION_TYPES.Approve &&
      selectedOption?.product_data?.input_type ===
        SERIALIZE_INPUT_TYPE.STEPPER &&
      selectedOption?.product_data?.mandate_check &&
      !(selectedQuantity > 0)
    )
      return true;

    // No product codes selected for multiple select
    if (
      selectedOption?.slug === ACTION_TYPES.Approve &&
      selectedOption?.product_data?.input_type ===
        SERIALIZE_INPUT_TYPE.MULTIPLE_SELECT &&
      selectedProductCodes?.length === 0
    )
      return true;

    return false;
  };

  const handleCloseActionView = () => {
    localStorage.setItem(IS_SIDEBAR_CLOSE, 'true');
    dispatch(closeActionView(true));
  };

  useEffect(() => {
    setIsMarkAsCompleteDisabled(checkMarkAsCompleteDisabled());
  }, [selectedOption, selectedQuantity, selectedProductCodes]);

  if (pageIndex === 0) {
    return (
      <ActiveAction.Content>
        {/* Sidebar close button and Search input field */}
        {activeActionIndex !== 0 && (
          <ActiveAction.Search className='tw-flex tw-items-center tw-h-[45px] tw-gap-2'>
            {dashboardMode !== 'smartplug' && isNewUI && (
              <Tooltip
                position={'bottom'}
                title={
                  <div
                    className='tw-group tw-h-[45px] tw-flex tw-items-center tw-justify-center tw-aspect-square tw-w-[45px] tw-rounded-xl tw-bg-white tw-border tw-border-solid tw-border-zinc-300 tw-transition-all tw-duration-200 tw-ease-in-out tw-cursor-pointer hover:tw-opacity-90'
                    onClick={handleCloseActionView}
                  >
                    <PanelRightClose
                      size={22}
                      className='tw-text-zinc-500 tw-transition-transform tw-duration-200 group-hover:tw-scale-105 group-hover:tw-text-base-green'
                      strokeWidth={1.7}
                    />
                  </div>
                }
                border={false}
                label='Click to close Action View'
              />
            )}
            <Input
              placeholder={
                activeActionIndex === TAB_INDEXES.QUICK_ACTION
                  ? 'Search an action...'
                  : activeActionIndex === TAB_INDEXES.REPORT_ISSUE
                  ? 'Search an issue...'
                  : 'Search here... '
              }
              type='text'
              showMaxLimit={false}
              onChange={onSearchAction(pageIndex)}
              inputStyleProps={{
                height: '45px',
                borderRadius: '8px !important',
                border: '1px solid #E5E7EB',
              }}
            />
          </ActiveAction.Search>
        )}

        {/* Save for Later issues */}
        {list?.pending_issues?.length ? (
          <IssuesListV2
            items={list.pending_issues}
            isPendingIssueList={true}
            handleActionClick={handleActionClick}
            setcomplaintType={setcomplaintType}
            goBack={goBack}
          />
        ) : null}

        {list?.items?.length ? (
          isResolutionService && activeActionIndex === 1 ? (
            <IssuesListV2
              items={list?.items}
              handleActionClick={handleActionClick}
              setcomplaintType={setcomplaintType}
              goBack={goBack}
            />
          ) : (
            <ActiveAction.ListContainer
              className={
                activeActionIndex === 0
                  ? 'tw-p-4 !tw-overflow-x-hidden tw-w-full'
                  : ''
              }
            >
              {/* OBD flow */}
              {activeActionIndex === 0 &&
                !liveOrderConfigData?.actions_allowed && (
                  <div
                    className={`tw-w-full tw-rounded-lg tw-border tw-border-solid
                    tw-p-4 tw-bg-green-100 tw-mb-2 tw-border-green-700/10 tw-flex tw-items-center tw-justify-center`}
                  >
                    <div className='tw-text-green-700 tw-font-medium'>
                      {liveOrderConfigData?.message}
                    </div>
                  </div>
                )}

              {activeActionIndex === 0 ? (
                list?.items?.map((item, index) => {
                  if (!item) return null;
                  return (
                    <TaskCard
                      taskKey={item?.id}
                      key={item?.id}
                      item={item}
                      handleActionClick={handleActionClick}
                      showAnimation={
                        index > list?.items?.length - newTasksCount - 1
                      }
                    />
                  );
                })
              ) : (
                <>
                  <IssuesListV2
                    items={list?.items.slice(0, 1)}
                    handleActionClick={handleActionClick}
                    setcomplaintType={setcomplaintType}
                    goBack={goBack}
                  />
                  {/* Pre del issues (includes cancellation flow) */}
                  {list?.heading && (
                    <div className='tw-px-6 tw-pt-6 tw-pb-3 tw-font-medium tw-text-[1.4rem] tw-leading-none tw-text-zinc-700'>
                      {list?.heading}
                    </div>
                  )}
                  <IssuesListV2
                    items={list?.items.slice(1)}
                    handleActionClick={handleActionClick}
                    setcomplaintType={setcomplaintType}
                    goBack={goBack}
                  />
                </>
              )}
            </ActiveAction.ListContainer>
          )
        ) : (
          <EmptyState
            img={defaultIssueImg}
            heading={errorText}
            subHeading={errorSubtext}
          />
        )}
      </ActiveAction.Content>
    );
  }

  if (pageIndex === 2 && activeActionIndex === TAB_INDEXES.LIVE_ORDER) {
    const taskDetails = list?.items?.[0];
    const { allowed_actions, product_card } = taskDetails || {};
    const reasons = selectedOption?.final_reasons?.reasons;
    const allowed_max_quantity =
      selectedOption?.product_data?.max_quantity ?? 0;

    // Get reasons for approve/reject
    const getReasons = () => {
      if (!reasons) return null;
      const items = [];

      reasons &&
        reasons.map((reason) => {
          const item = {};
          item['text'] = reason.title;
          item['value'] = reason.slug;
          items.push(item);
          return true;
        });

      return items;
    };

    // Handle Mark as Complete
    const handleMarkAsComplete = () => {
      if (!liveOrderConfigData?.actions_allowed) return;
      if (
        selectedOption?.slug === ACTION_TYPES.Approve &&
        selectedOption?.product_data?.input_type ===
          SERIALIZE_INPUT_TYPE.MULTIPLE_SELECT &&
        selectedProductCodes?.length > allowed_max_quantity
      ) {
        toast.error(
          `You can select a maximum of ${allowed_max_quantity} product ${
            allowed_max_quantity === 1 ? 'code' : 'codes'
          }.`,
        );
        return;
      }

      const ReasonKey =
        selectedOption?.slug === ACTION_TYPES.Reject
          ? 'rejectionReason'
          : 'updatedTaskType';

      const quantityValue =
        selectedOption?.product_data?.input_type ===
        SERIALIZE_INPUT_TYPE.STEPPER
          ? selectedQuantity
          : selectedProductCodes?.length;

      const updatedProductData =
        selectedOption?.product_data?.input_type ===
        SERIALIZE_INPUT_TYPE.STEPPER
          ? {
              quantity: quantityValue,
            }
          : {
              quantity: quantityValue,
              product_codes: selectedProductCodes.map((code) => code.name),
            };

      handleActionClick(
        taskDetails,
        false,
        {},
        {
          isUpdatingTask: true,
          status: selectedOption?.next_status || 'COMPLETED',
          refreshTask: true,
          [ReasonKey]: selectedOption?.finalSelectedReason,
          subStatus: selectedOption?.slug,
          updated_product_data: updatedProductData,
        },
      );
    };

    if (!liveOrderConfigData?.actions_allowed)
      return <div>You are not allowed to view live order details.</div>;

    return (
      <div className='tw-overflow-auto tw-justify-between tw-p-8 tw-flex tw-flex-col tw-h-full'>
        <div className='tw-flex-col tw-gap-4 tw-w-full'>
          {/* Approve and Reject buttons */}
          <div className='tw-flex tw-items-center tw-justify-between tw-gap-4'>
            {allowed_actions?.map((action) => {
              if (!action) return null;
              return (
                <button
                  key={action.slug}
                  className={`tw-flex tw-w-1/2 tw-h-[40px] tw-rounded-lg tw-aspect-square tw-border-none tw-items-center tw-justify-center tw-gap-2 tw-cursor-pointer ${`tw-text-[${action.text_color}]`}  
                ${
                  selectedOption?.slug === action.slug
                    ? action.slug === ACTION_TYPES.Approve
                      ? `tw-border-green-700 tw-border-solid tw-border-[1px]`
                      : `tw-border-red-700 tw-border-solid tw-border-[1px]`
                    : ''
                }
                `}
                  style={{
                    color: action.text_color,
                    backgroundColor: action.bg_color,
                  }}
                  onClick={() => {
                    setSelectedOption(action);
                    setSelectedQuantity(null);
                    setSelectedProductCodes([]);
                  }}
                >
                  {action?.slug === ACTION_TYPES.Approve ? (
                    <Check color={action.text_color} />
                  ) : (
                    <Cross color={action.text_color} />
                  )}
                  {action.title}
                </button>
              );
            })}
          </div>

          {/* Approval and Rejection Reasons*/}
          {selectedOption?.final_reasons?.reasons &&
            (selectedOption?.final_reasons?.reasons?.length > 0 ? (
              <div className='tw-mt-4 tw-flex tw-flex-col tw-gap-8 tw-w-full'>
                {/* Stepper */}
                {selectedOption?.slug === ACTION_TYPES.Approve &&
                  selectedOption?.product_data?.input_type ===
                    SERIALIZE_INPUT_TYPE.STEPPER && (
                    <MultiSelectViewV2
                      items={[
                        {
                          text: product_card?.title || '',
                          id: product_card?.title || '',
                          item_image_url: product_card?.image_url || '',
                          unit_cost_text: `₹${product_card?.price}`,
                          quantity: product_card?.quantity,
                          max_quantity: allowed_max_quantity || '',
                          price: product_card?.price,
                          pickup_selected: true,
                          pickup_enabled: false,
                          substitute_available:
                            product_card?.substitutable || false,
                        },
                      ]}
                      selectItems={(items) => {
                        if (!Object.values(items).length) {
                          setSelectedQuantity(0);
                          return;
                        }
                        setSelectedQuantity(Object.values(items)[0].quantity);
                      }}
                      showPickupCheckbox={false}
                    />
                  )}

                {/* Product codes dropdown */}
                {selectedOption?.product_data?.input_type ===
                  SERIALIZE_INPUT_TYPE.MULTIPLE_SELECT && (
                  <div className='tw-w-full tw-flex tw-flex-col tw-justify-end'>
                    <div className='tw-text-[1.4rem] tw-font-medium tw-mb-6'>
                      {allowed_max_quantity === 1
                        ? 'Select a product code you wish to approve:'
                        : `Select the product code(s) you wish to approve. You can select up to ${allowed_max_quantity} codes:`}
                    </div>
                    <div className='tw-w-full tw-flex tw-h-18 tw-rounded-xl tw-outline-0 tw-gap-2 tw-cursor-pointer  tw-items-center'>
                      <div
                        className='tw-flex tw-w-full'
                        id='search-category-input-return-config'
                        css={dropdownInputCSS}
                      >
                        <Multiselect
                          options={selectedOption?.product_data?.product_codes?.map(
                            (option) => ({
                              id: option,
                              name: option,
                            }),
                          )}
                          loading={false}
                          showArrow
                          placeholder={'Example: 6-TPA-0000M'}
                          hidePlaceholder={selectedProductCodes?.length > 0}
                          onSelect={(selectedCodes) => {
                            setSelectedProductCodes([...selectedCodes]);
                          }}
                          onRemove={(remainingCodes) => {
                            setSelectedProductCodes([...remainingCodes]);
                          }}
                          avoidHighlightFirstOption
                          displayValue='name'
                          selectionLimit={allowed_max_quantity}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Reasons */}
                <div className='tw-flex-col'>
                  <span className='tw-text-[1.4rem] tw-font-medium tw-mb-6'>
                    {selectedOption?.final_reasons?.title ??
                      'Please select a reason'}
                    {selectedOption?.final_reasons?.mandate_check ? (
                      <span className='tw-text-red-500'>*</span>
                    ) : (
                      ' (optional)'
                    )}
                  </span>
                  <RadioGroup
                    items={getReasons()}
                    selectOption={(reason) => {
                      setSelectedOption((prev) => ({
                        ...prev,
                        finalSelectedReason: reason,
                      }));
                    }}
                  />
                </div>
              </div>
            ) : (
              <EmptyState
                img={InvalidSearchImg}
                heading='No rejection reasons available'
              />
            ))}
        </div>

        {/* Button Group */}
        <div className='tw-w-full tw-flex-col tw-mt-16 tw-gap-4'>
          <button
            className='tw-rounded-[8px] tw-p-[10px] tw-bg-green-700 tw-text-white tw-font-okra tw-text-[14px] tw-w-full tw-cursor-pointer tw-border-none disabled:tw-cursor-not-allowed disabled:tw-bg-[#CFCFCF]'
            onClick={handleMarkAsComplete}
            disabled={isMarkAsCompleteDisabled}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }

  if (pageIndex !== 0) {
    // For live order tasks
    if (list?.type === 'tasks') {
      const taskDetails = list?.items?.[0];
      const {
        description,
        sops,
        user_comment_and_media,
        product_card,
        allowed_actions,
        status,
        update_ts,
      } = taskDetails || {};

      let updatedAt = new Date(update_ts);
      let formattedUpdatedAtDate, formattedUpdatedAtTime;

      if (!update_ts || isNaN(updatedAt.getTime())) {
        formattedUpdatedAtDate = null;
        formattedUpdatedAtTime = null;
      } else {
        try {
          formattedUpdatedAtDate = updatedAt.toLocaleDateString('en-GB');
          formattedUpdatedAtTime = updatedAt.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          });
        } catch (error) {
          formattedUpdatedAtDate = null;
          formattedUpdatedAtTime = null;
        }
      }

      const handleViewCommentMedia = () => {
        setIsModalVisible(true);
      };

      return (
        <div className='tw-overflow-auto tw-justify-between tw-p-8 tw-flex tw-flex-col tw-h-full'>
          <div className='tw-flex-col tw-gap-8'>
            {/* Description */}
            {description}

            {/* Product Card */}
            {product_card && (
              <div className='tw-rounded-[12px] tw-p-4 tw-border-grey-200 tw-border-solid tw-border tw-h-full tw-flex tw-gap-4 tw-overflow-hidden'>
                <div className='tw-w-[90px] tw-aspect-square tw-h-[90px] tw-flex tw-items-center tw-justify-center tw-rounded-xl'>
                  <ZImage
                    src={product_card.image_url}
                    width='100%'
                    height='100%'
                    style={{
                      borderRadius: '12px',
                    }}
                    alt='product_image'
                    imgAlt='product_image'
                  />
                </div>
                <div
                  className={`tw-flex tw-flex-col tw-w-full tw-justify-start ${
                    product_card?.product_codes?.length > 0
                      ? 'tw-gap-2'
                      : 'tw-gap-4'
                  }`}
                >
                  <span className='tw-text-[1.4rem]'>{product_card.title}</span>
                  {product_card?.product_codes?.length > 0 && (
                    <div className='tw-flex'>
                      <span className='tw-inline-flex tw-w-auto tw-text-grey-700 tw-rounded-lg tw-p-2 tw-border tw-border-grey-200 tw-border-solid tw-bg-grey-100 tw-text-[12px] tw-leading-none tw-whitespace-nowrap'>
                        {product_card?.product_codes?.join(', ')}
                      </span>
                    </div>
                  )}
                  <span className='tw-text-[12px] tw-leading-none tw-text-grey-700'>
                    {product_card.quantity}{' '}
                    {Number(product_card.quantity) === 1 ? 'unit' : 'units'}
                  </span>
                  <span className='tw-text-[12px] tw-leading-none'>
                    ₹{product_card.price}
                  </span>
                </div>
              </div>
            )}

            {/* User Comment and Media */}
            {user_comment_and_media?.title && (
              <p className='colorGreen' onClick={handleViewCommentMedia}>
                {user_comment_and_media?.title}
              </p>
            )}

            {/* SOPs */}
            {sops?.length > 0 ? (
              <div className='tw-flex tw-flex-col tw-w-full'>
                <div className='tw-text-lg tw-font-medium'>
                  Please follow these steps carefully:
                </div>
                <div className='tw-flex-col tw-mt-4 tw-gap-4'>
                  {sops.map((SOP, index) => (
                    <div
                      key={index}
                      className='tw-flex tw-items-start tw-gap-2'
                    >
                      <span className='tw-aspect-square tw-w-7 tw-h-full'>
                        {index + 1}.
                      </span>
                      <span>{SOP}</span>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>

          {/* Button Group */}
          <div className='tw-w-full tw-flex-col tw-mt-8 tw-gap-4'>
            {allowed_actions?.length !== 0 &&
            liveOrderConfigData?.actions_allowed ? (
              allowed_actions?.length > 1 ? (
                <div className='tw-w-full tw-flex-col tw-mt-8 tw-gap-4'>
                  <button
                    className='tw-rounded-[8px] tw-p-[10px] tw-bg-green-700 tw-text-white tw-font-okra tw-text-[14px] tw-w-full tw-cursor-pointer tw-border-none'
                    onClick={() => handleActionClick(taskDetails, false)}
                  >
                    Next
                  </button>
                </div>
              ) : (
                <button
                  className='tw-rounded-[8px] tw-p-[10px] tw-bg-green-700 tw-text-white tw-font-okra tw-text-[14px] tw-w-full tw-cursor-pointer tw-border-none disabled:tw-cursor-not-allowed disabled:tw-bg-[#CFCFCF]'
                  onClick={() =>
                    handleActionClick(
                      taskDetails,
                      false,
                      {},
                      {
                        isUpdatingTask: true,
                        status: allowed_actions?.[0]?.next_status,
                        subStatus: allowed_actions?.[0]?.slug,
                        refreshTask: true,
                      },
                    )
                  }
                >
                  Submit
                </button>
              )
            ) : (
              taskDetails?.status?.slug !== TASK_STATUSES.OPEN && (
                <>
                  {formattedUpdatedAtDate && formattedUpdatedAtTime ? (
                    <div className='tw-text-center tw-mx-auto tw-flex tw-items-center tw-flex-col'>
                      <span className='tw-text-[10px] tw-uppercase tw-font-medium tw-text-grey-700'>
                        Last updated
                      </span>
                      <span className='tw-text-grey-800 tw-text-[1.4rem] tw-font-medium'>
                        {formattedUpdatedAtTime}, {formattedUpdatedAtDate}
                      </span>
                    </div>
                  ) : null}
                  <div
                    className={
                      'tw-rounded-[8px] tw-p-[10px] tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between'
                    }
                    style={{
                      color: status?.text_color,
                      backgroundColor: status?.bg_color,
                    }}
                  >
                    {status?.title && (
                      <span className='tw-text-[1.4rem] tw-font-medium tw-w-full tw-text-center'>
                        This task was{'  '}
                        <span className='tw-lowercase'>
                          {taskDetails?.status?.title}
                        </span>
                      </span>
                    )}
                    {status?.reason && (
                      <span className='tw-text-[12px] tw-font-medium tw-w-full tw-text-center tw-opacity-80'>
                        Reason: {taskDetails?.status?.reason}
                      </span>
                    )}
                  </div>
                </>
              )
            )}
          </div>

          {isModalVisible && (
            <CxCommentMediaModal
              isVisible={isModalVisible}
              handleClose={() => setIsModalVisible(false)}
              taskDetails={taskDetails}
            />
          )}
        </div>
      );
    }
    if (list.isGrouped) {
      return (
        <GroupedReasons
          reasons={list.items}
          getIssuesInfo={handleActionClick}
          cancellationWarning={list.cancellationWarning}
        />
      );
    } else {
      return (
        <ReportIssue
          selectedValue={list.selectedValue}
          resetSmartplugState={resetSmartplugState}
          list={list.items[0]}
          orderId={orderId}
          cartId={cartId}
          complaintType={complaintType}
          userId={userId}
          handleCardLink={handleCardLink}
          isResolutionService={isResolutionService}
          goBack={goBack}
          mediaValidation={
            currentAction
              ? currentAction[activeActionIndex]?.mediaValidation
              : null
          }
          skipItemSelectionScreen={
            currentAction
              ? currentAction[activeActionIndex]?.skipItemSelectionScreen
              : null
          }
          complaintId={
            currentAction ? currentAction[activeActionIndex]?.complaintId : null
          }
          preSelectedItems={
            currentAction
              ? currentAction[activeActionIndex]?.selected_items
              : null
          }
          orderLevelPayload={
            currentAction
              ? currentAction[activeActionIndex]?.orderLevelPayload
              : null
          }
        />
      );
    }
  }

  return null;
};

function CxCommentMediaModal({ taskDetails, isVisible, handleClose }) {
  const [showFullComment, setShowFullComment] = useState(false);
  const { user_comment_and_media } = taskDetails || {};
  const { comment, media } = user_comment_and_media || {};

  const handleCopyComment = () => {
    if (!comment) return;
    navigator.clipboard.writeText(comment);
    toast.success('Comment copied to clipboard');
  };

  const Comment = () => {
    if (comment?.length > 200) {
      return showFullComment ? (
        <span>
          {comment}
          <span
            className='tw-text-green-700 tw-cursor-pointer'
            onClick={() => setShowFullComment(false)}
          >
            {' '}
            Show less
          </span>
        </span>
      ) : (
        <span>
          {comment.slice(0, 200)}...
          <span
            className='tw-text-green-700 tw-cursor-pointer'
            onClick={() => setShowFullComment(true)}
          >
            {' '}
            Show more
          </span>
        </span>
      );
    }
    return <span>{comment}</span>;
  };

  return (
    <Modal
      isMaxContent
      isVisible={isVisible}
      type='large'
      padding={0}
      paddingTop={'1rem'}
      maxHeight={'90vh'}
      containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
      title={user_comment_and_media?.title || 'View User comment and Media'}
      handleClose={handleClose}
      component={
        <div>
          {/* Customer Comment */}
          <div className='tw-mb-10'>
            <div
              className='tw-text-[1.4rem] tw-font-medium tw-mb-6 tw-flex tw-items-center tw-gap-2 tw-cursor-pointer'
              onClick={handleCopyComment}
            >
              Comment{comment && <Copy size={14} color={green.z700} />}
            </div>
            <div className='tw-rounded-lg tw-p-4 tw-bg-grey-100 tw-text-grey-700'>
              {comment ? <Comment /> : 'No comments provided by the user.'}
            </div>
          </div>

          {/* Customer Media */}
          <div className='tw-mb-4'>
            <div
              className='tw-text-[1.4rem] tw-font-medium tw-mb-6 tw-flex tw-items-center tw-gap-2 tw-cursor-pointer'
              onClick={handleCopyComment}
            >
              Uploaded Media
            </div>
            {(!media || media.length === 0) && (
              <EmptyState
                img={InvalidSearchImg}
                heading='Customer has not submitted any images'
              />
            )}
            {media?.length > 0 ? (
              <MultiMedia
                images={media.map((img) => ({
                  src: img?.url,
                  type: img?.type,
                }))}
                mediaStyle={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
                title='Customer Media'
              />
            ) : null}
          </div>
        </div>
      }
    />
  );
}

const TaskCard = ({
  item,
  handleActionClick,
  taskKey,
  showAnimation = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isRendered, setIsRendered] = useState(false);

  let createdAt = new Date(item?.install_ts);
  let formattedCreatedAtDate, formattedCreateAtTime;

  if (!item?.install_ts || isNaN(createdAt.getTime())) {
    formattedCreatedAtDate = null;
    formattedCreateAtTime = null;
  } else {
    try {
      formattedCreatedAtDate = createdAt.toLocaleDateString('en-GB');
      formattedCreateAtTime = createdAt.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });
    } catch (error) {
      formattedCreatedAtDate = null;
      formattedCreateAtTime = null;
    }
  }

  let updatedAt = new Date(item?.update_ts);
  let formattedUpdatedAtDate, formattedUpdatedAtTime;

  if (!item?.update_ts || isNaN(updatedAt.getTime())) {
    formattedUpdatedAtDate = null;
    formattedUpdatedAtTime = null;
  } else {
    try {
      formattedUpdatedAtDate = updatedAt.toLocaleDateString('en-GB');
      formattedUpdatedAtTime = updatedAt.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });
    } catch (error) {
      formattedUpdatedAtDate = null;
      formattedUpdatedAtTime = null;
    }
  }

  // Calculate total time taken for the task
  const totalTimeTaken = (() => {
    if (!item?.update_ts || !item?.install_ts) return '0 mins 0 seconds';
    const totalTime = new Date(item?.update_ts) - new Date(item?.install_ts);
    const totalTimeInSeconds = Math.floor(totalTime / 1000);
    const totalTimeInMinutes = Math.floor(totalTimeInSeconds / 60);
    const remainingSeconds = totalTimeInSeconds % 60;
    return `${totalTimeInMinutes} mins ${remainingSeconds} seconds`;
  })();

  const handleTaskCardClick = () => {
    const updatedTaskData =
      item.status?.slug === TASK_STATUSES.OPEN
        ? {
            isUpdatingTask: true,
            status: TASK_STATUSES.inProgress,
            subStatus: TASK_STATUSES.inProgress,
          }
        : null;
    handleActionClick(item, false, {}, updatedTaskData);
  };

  useEffect(() => {
    setIsRendered(true);
  }, []);

  if (!item) return null;

  return (
    <ActiveAction.List
      key={taskKey}
      onClick={handleTaskCardClick}
      className={`tw-max-w-full tw-rounded-lg tw-border tw-border-solid
                  tw-p-4 tw-bg-grey-100 hover:tw-bg-grey-200/40 tw-border-grey-300/40 hover:tw-border-grey-300/70 tw-transition-all tw-ease-in-out tw-duration-200
                   ${
                     isRendered && showAnimation
                       ? 'tw-animate-slide-in-right'
                       : ''
                   }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ willChange: 'transform, opacity' }}
    >
      <div className='tw-flex tw-flex-col tw-gap-5 tw-w-full'>
        <div className='tw-flex tw-items-center tw-justify-between tw-gap-2 tw-w-full'>
          <span className='tw-text-[1.4rem] tw-font-medium tw-text-[#1C1C1C]'>
            Task {item.task_number}: {item.title}
          </span>
          <Tag
            textColor='#4F4F4F'
            className={`tw-capitalize ${getTagStyles(
              item?.status?.slug,
            )} tw-text-[12px] tw-whitespace-nowrap`}
          >
            {item?.status?.title}
          </Tag>
        </div>
        <div className='tw-w-full tw-h-px tw-bg-base-black/10  tw-rounded-full' />
        <div className='tw-flex tw-items-center tw-justify-between tw-w-full'>
          <div className='tw-flex tw-gap-2'>
            <Tag
              textColor='#4F4F4F'
              className='tw-capitalize tw-bg-grey-200/80 tw-text-[12px] tw-whitespace-nowrap'
            >
              Source: {TaskSourceLabels[item?.source]}
            </Tag>
            {formattedCreatedAtDate && formattedCreateAtTime && (
              <div className='tw-relative tw-group'>
                <div className='tw-text-grey-500 tw-aspect-square tw-flex tw-items-center tw-justify-center tw-h-9 tw-rounded-[4px] tw-p-1 tw-bg-grey-200/80 hover:tw-text-grey-700 tw-transition-all tw-duration-200 tw-cursor-pointer tw-w-9'>
                  <ClockPlus size={14} aria-hidden='true' />
                </div>
                <div className='tw-absolute tw-z-50 tw-bg-grey-200 tw-rounded-lg tw-text-grey-700 tw-font-medium tw-border-[1px] tw-border-grey-300 tw-border-solid tw-px-4 tw-py-2 tw-bottom-full tw-left-1/2 tw-transform tw--translate-x-1/2 tw-mb-2 tw-whitespace-nowrap tw-opacity-0 tw-pointer-events-none group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-flex tw-flex-col tw-gap-1 tw-leading-tight'>
                  <span className='tw-text-[12px]'>
                    Created At: {formattedCreateAtTime},{' '}
                    {formattedCreatedAtDate}
                  </span>
                  {item.status?.slug !== TASK_STATUSES.OPEN &&
                  formattedUpdatedAtTime &&
                  formattedUpdatedAtDate ? (
                    <span className='tw-text-[12px]'>
                      {item.status?.slug === TASK_STATUSES.inProgress
                        ? 'Updated At: '
                        : 'Completed At: '}
                      {formattedUpdatedAtTime}, {formattedUpdatedAtDate}
                    </span>
                  ) : null}
                  {item.status?.slug !== TASK_STATUSES.inProgress &&
                  item.status?.slug !== TASK_STATUSES.OPEN &&
                  totalTimeTaken ? (
                    <span className='tw-text-[12px]'>
                      Time taken: {totalTimeTaken}
                    </span>
                  ) : null}
                </div>
              </div>
            )}
          </div>
          <div
            className={`${
              isHovered ? 'tw-transform tw-translate-x-[2px]' : ''
            } tw-transition-all tw-duration-200`}
          >
            <ChevronRight size={20} color={isHovered ? grey.z600 : '#9c9c9c'} />
          </div>
        </div>
      </div>
    </ActiveAction.List>
  );
};

ActiveAction.Content = styled.div`
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

ActiveAction.Search = styled.div`
  margin: 1.4rem;
  margin-bottom: 1rem;
`;

ActiveAction.ListContainer = styled.div`
  flex-direction: column;
  display: flex;
  margin: 1rem 0;
  overflow: auto;
  //height: 65vh;
  padding-bottom: 25rem;
`;

ActiveAction.List = styled.div`
  margin: 0.5rem 0;
  background: #fbfbfb;
  color: ${(props) => (props.disabled ? '#B8B8B8' : '#363636')};
  padding: 1.5rem 2rem;
  // opacity: ${(props) => (props.disabled ? '0.3' : '1')};
  cursor: ${(props) => (props.disabled ? 'no-drop' : 'pointer')};
  img {
    width: 2rem;
  }
`;

const Tag = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.6rem;
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  font-size: 1.1rem;
  border-radius: 0.4rem;
  font-weight: 500;
  line-height: normal;
`;
